export const VideoSection = () => {
  return (
    <section className="py-24 section-blue relative overflow-hidden">
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Nasze <span className="text-gradient">realizacje</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Zobacz, jak wyglądają nasze atrakcje w akcji
        </p>
        <div className="max-w-4xl mx-auto space-y-10">
          <div className="card-highlight p-2">
            <div className="aspect-video rounded-xl overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/uCFP0P8mzIg"
                title="Atrakcje eventowe dla firm - WystepyFirmowe.pl"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <div className="card-highlight p-2">
            <div className="aspect-video rounded-xl overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/Wjd8tuRphjw"
                title="Show artystyczne na evencie firmowym"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <p className="text-center mt-8 text-muted-foreground max-w-2xl mx-auto">
            Każda realizacja jest dopasowywana do specyfiki branży klienta, wielkości grupy 
            i charakteru wydarzenia. Gwarantujemy najwyższy standard obsługi i niezapomniane wrażenia.
          </p>
        </div>
      </div>
    </section>
  );
};
